export default {
  name: 'PublicEntityCard',
  props: {
    to: {
      type: [Object, String],
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    backgroundImage: {
      type: String,
      default: '',
    },
    imageMode: {
      type: Boolean,
      default: false,
    },
    scrollCard: {
      type: Boolean,
      default: false,
    },
    accentType: {
      type: String,
      default: '',
    },
  },
  computed: {
    cardClass() {
      return {
        'public-entity-card--image': this.imageMode,
        'public-entity-card--scroll': this.scrollCard,
        'public-entity-card--clickable': Boolean(this.to),
        [`public-entity-card--${this.accentType}`]: Boolean(this.accentType),
      };
    },

    cardStyle() {
      return this.backgroundImage
        ? { backgroundImage: this.backgroundImage }
        : null;
    },
  },
  methods: {
    openCard(event) {
      if (!this.to) return;
      if (event?.target?.closest?.('a, button, [role="button"], .dropdown-menu, .dropdown-toggle')) return;

      this.$router.push(this.to);
    },
  },
};
